var map = {
	"./hero-blacksmith.jpg": "2E2n",
	"./hero-welder-01.jpg": "zz+i",
	"./hero-welder-02.jpg": "AAOk",
	"./img-life.jpg": "fQUa",
	"./logo-500x500.png": "pa+h",
	"./logo.png": "ATp1",
	"./pattern.png": "JYSF",
	"./sanity/disability.png": "OfqD",
	"./sanity/funeral.png": "x2yO",
	"./sanity/life.png": "4jqI",
	"./social-call-me.jpg": "pWxb",
	"./social-contact.jpg": "Ravb",
	"./social-faqs.jpg": "gtbj",
	"./social-generic.jpg": "v8og",
	"./social-home.jpg": "vA9o",
	"./social-how-to-claim.jpg": "d8Zz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";